'use client';

import { styled } from 'styled-components';

import Button from '@dvd/components/Button';
import { WISTIA_BUSINESS_TRIAL, WISTIA_GIT } from '@lib/constants';

import { accentGradient } from '../_design/css';
import { Eyebrow, SectionTitle } from '../_design/styled';

const Band = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1.5]};
  overflow: clip;
  padding-block: ${({ theme }) => theme.spacing[6]};
  padding-inline: ${({ theme }) => theme.grid.margin.small};
  position: relative;
  text-align: center;

  ${({ theme }) => theme.mq.minWidth.large} {
    padding-block: ${({ theme }) => theme.spacing[8]};
  }
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1.5]};
  position: relative;
  z-index: 1;
`;

const Headline = styled(SectionTitle)`
  line-height: 1.1;
  max-width: 52rem;

  em {
    font-style: normal;
    ${accentGradient}
  }
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[1.5]};
  justify-content: center;
  margin-block-start: ${({ theme }) => theme.spacing[1]};
`;

/** Closing call to action, on the same aurora field the page opened with. */
const DarkHomeCta = () => {
  return (
    <Band aria-labelledby="get-started-title" id="get-started">
      <Content>
        <Eyebrow>Video & webinar platform</Eyebrow>
        <Headline id="get-started-title">
          All your video and webinar needs. All in <em>one platform</em>.
        </Headline>
        <Actions>
          <Button
            color="blue500"
            href={WISTIA_BUSINESS_TRIAL}
            trackingLabel="sign-up-for-free"
            trackingProperty="dark-home-closing-cta"
          >
            Sign up for free
          </Button>
          <Button
            color="blue300"
            href={WISTIA_GIT}
            trackingLabel="get-in-touch"
            trackingProperty="dark-home-closing-cta"
            variant="secondary"
          >
            Get in touch
          </Button>
        </Actions>
      </Content>
    </Band>
  );
};

export default DarkHomeCta;
